import React from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license-pro';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery';

LicenseInfo.setLicenseKey(
  'd3452d29cea6144913acd73f4e4cc7efTz0xMTYxNzAsRT0xNzg0MTU5OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
);

installChunkLoadRecovery();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <App />
  </LocalizationProvider>,
);

reportWebVitals();
